export const SUCCESS_RESPONSE = {
  OK: "H0004",
  CREATED: "H0001",
  SUCCESFUL: "H0004",
  ADDED_TO_QUEUE: "H0028",
};

export const ERROR_RESPONSE = {
  FORBIDDEN: "H0010",
  TOKEN_EXPIRED: "H0002",
  INVALID_CREDENTIALS: "H0005",
  UNVERIFIED: "H0006",
  BANNED: "H0007",
  INVALID_TOKEN: "H0009",
  BAD_REQUEST: "H0013",
  DATA_NOT_FOUND: "H0014",
  UNPROCESSABLE_DATA: "H0015",
  MAX_DEVICE: "H0008",
  PENDING_ALREADY_EXIST: "H0029",
  DATE_NOT_ACCEPTABLE: "H0026",
  VOTING_ALREADY_DONE: "H0020",
  PERIOD_NO_EXIST: "H0036",
  PERIOD_EXIST: "H0037",
  NO_FINANCES_TO_PROCESS: "H0041",
  UNFINISHED_VOTING: "H0022",
  PAYMENT_IN_PROCESS: "H0038",
  TOO_MANY_REQUESTS: "H0044",
  ACCOUNT_WITHOUT_PROPERTIES: "H0045",
};
